import { useContext, useMemo, useLayoutEffect, useRef, useState } from 'react';
import { MyContext } from '../Store';
import { getSketchData, getFileName, viewsMap } from '../utils';
import { MarkingZone } from './Marking';

export const Sketches = ({ selectedView, className }) => {
  const [state] = useContext(MyContext);
  const { productData, selectedMods, selectedMarking, colorData } = state;

  const [mainLayerWidth, setMainLayerWidth] = useState(null);
  const [mainLayerHeight, setMainLayerHeight] = useState(null);

  const previewRef = useRef(null);
  const mainLayerRef = useRef(null);

  const vendoCodes = useMemo(
    () => [productData.vendo_code.slice(0, -2), productData.vendo_code],
    [productData.vendo_code],
  );

  const layers = useMemo(() => {
    const layersFound = [];

    Object.values(selectedMods).forEach(mod => {
      if (mod.sketches && mod.sketches.length) {
        const matchSketch = mod.sketches.find(sketch => {
          const sketchInfo = getSketchData(getFileName(sketch));
          return sketchInfo.view === selectedView && vendoCodes.includes(sketchInfo.matchCode);
        });

        if (matchSketch) {
          if (mod.topLayer) {
            layersFound.push(matchSketch);
          } else {
            layersFound.unshift(matchSketch);
          }
        } else {
          console.log(`Brak szkicu modyfikacji ${mod.name} dla wybranego widoku lub koloru`);
        }
      } else {
        console.warn(`UWAGA: brak szkiców modyfikacji ${mod.name}`);
      }
    });

    return layersFound;
  }, [selectedMods, selectedView, vendoCodes]);

  useLayoutEffect(() => {
    const observer = new ResizeObserver(entries => {
      const el = entries[0].contentRect;
      if (el.width > 0 && el.height > 0) {
        setMainLayerWidth(el.width);
        setMainLayerHeight(el.height);
      }
    });
    observer.observe(mainLayerRef.current);

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    return () => mainLayerRef.current && observer.unobserve(mainLayerRef.current);
  }, []);

  return (
    <div className={`${className} sketches`} ref={previewRef}>
      <img
        src={colorData.sketches?.[selectedView]?.image}
        className="sketch main-sketch"
        alt="main"
        ref={mainLayerRef}
      />
      {layers.map(layer => (
        <img src={layer} className="sketch layer-sketch" alt="layer" key={layer} />
      ))}
      {selectedView === viewsMap.FRONT && selectedMarking.id && mainLayerWidth && mainLayerHeight && (
        <MarkingZone width={mainLayerWidth} height={mainLayerHeight} />
      )}
    </div>
  );
};
